/**
 * Auth shell background for login/register before React paints.
 * Default: green. With ?vt=white (marketing white cover): white — see index.html.
 * Keep the pathname regex in public/index.html in sync with this pattern.
 */
export const AUTH_SHELL_ROUTE_PATTERN = /^\/(login|register)(\/|$)/;

export function isAuthShellRoute(pathname: string): boolean {
  return AUTH_SHELL_ROUTE_PATTERN.test(pathname);
}
